import React, { useCallback, useEffect, useRef, useState } from 'react'
import { havenOnEarth } from './eventDetails'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { FiMenu, FiX, FiArrowUpRight } from 'react-icons/fi'
import logo from './press/assets/haven-logo.png'

const links = [['/', 'Haven on Earth'], ['/waitlist', 'Waitlist'], ['/about', 'About'], ['/help', 'Help'], ['/media-and-press', 'Media & press']]

export const Navigation = () => {
  const [open, setOpen] = useState(false)
  const dialog = useRef(null)
  const toggle = useRef(null)
  const location = useLocation()
  const closing = useRef(false)
  const closeAnimation = useRef(null)
  const close = useCallback(() => {
    const panel = dialog.current
    if (!panel?.open || closing.current) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.close()
      return
    }
    closing.current = true
    closeAnimation.current = panel.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }],
      { duration: 220, easing: 'ease-in', fill: 'forwards' }
    )
    closeAnimation.current.onfinish = () => {
      panel.close()
      closeAnimation.current?.cancel()
      closeAnimation.current = null
      closing.current = false
    }
  }, [])
  useEffect(() => () => { closeAnimation.current?.cancel() }, [])
  useEffect(() => {
    if (!open) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = previous }
  }, [open])
  useEffect(() => { close() }, [location.pathname, close]) // Route changes use the same exit animation.
  const show = () => { dialog.current?.showModal(); setOpen(true) }
  const navLinks = (sidebar = false) => links.map(([url, label]) => <NavLink key={url} to={url} end={url === '/'} onClick={sidebar ? close : undefined} className={({isActive}) => isActive ? 'is-active' : ''}>{label}{sidebar && <FiArrowUpRight aria-hidden='true'/>}</NavLink>)
  return <div className='haven-header'>
    <div className='haven-announcement'><div className='haven-announcement-window'><div className='haven-announcement-track'>{[0, 1].map(group => <div className='haven-announcement-group' key={group} aria-hidden={group === 1 ? true : undefined}>{[0, 1, 2].map(copy => <p key={copy} aria-hidden={copy > 0 ? true : undefined}>Haven on Earth is coming on <time dateTime={havenOnEarth.dateTime}>7-11</time>. <span>Free entry.</span></p>)}</div>)}</div></div><Link to='/register-launch'>Register for free <FiArrowUpRight aria-hidden='true'/></Link></div>
    <header className='haven-navbar'>
      <Link to='/' className='haven-logo' aria-label='Haven home'><img src={logo} alt='Haven' width='136' height='39'/></Link>
      <nav aria-label='Main navigation'>{navLinks()}</nav>
      <button ref={toggle} className='haven-menu-toggle' onClick={show} aria-label='Open navigation' aria-expanded={open} aria-controls='haven-sidebar'><FiMenu aria-hidden='true'/></button>
    </header>
    <dialog ref={dialog} id='haven-sidebar' className='haven-sidebar' aria-label='Haven navigation' onCancel={e=>{e.preventDefault();close()}} onClose={()=>{setOpen(false);toggle.current?.focus()}} onClick={e=>{if(e.target===e.currentTarget && e.clientX>e.currentTarget.getBoundingClientRect().right) close()}}>
      <div className='haven-sidebar-top'><Link to='/' aria-label='Haven home' onClick={close}><img src={logo} alt='Haven' width='136' height='39'/></Link><button onClick={close} aria-label='Close navigation'><FiX aria-hidden='true'/></button></div>
      <nav aria-label='Sidebar navigation'>{navLinks(true)}</nav>
      <div className='haven-sidebar-invite'><h2>See you in real life?</h2><p>Haven on Earth. Free entry.<br/><time dateTime={havenOnEarth.dateTime}>{havenOnEarth.date}</time><br/>{havenOnEarth.location}</p><Link to='/register-launch' onClick={close} className='haven-action'>Register for free <FiArrowUpRight aria-hidden='true'/></Link></div>
      <a className='haven-sidebar-email' href='mailto:Hello@yourhaven.ng'>Hello@yourhaven.ng</a>
    </dialog>
  </div>
}
